import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MarketplaceRfq } from '~proto/marketplace/rfq_pb';
import { MarketplaceRfqStatus } from '~proto/types/types_pb';
import { MarketplaceService } from '~services/marketplace.service';

@Component({
  selector: 'ct-marketplace-cancelled-rfq',
  styleUrls: ['./marketplace-cancelled-rfq.component.scss'],
  templateUrl: './marketplace-cancelled-rfq.component.html',
})
export class MarketplaceCancelledRfqComponent implements OnInit, OnDestroy {
  constructor(private marketplaceService: MarketplaceService) {}
  public cancelledRfq$$ = new BehaviorSubject<MarketplaceRfq.AsObject[]>(null);
  public rfqType = MarketplaceRfqStatus;

  public ngOnInit() {
    this.marketplaceService.allRFQ$.subscribe((rfqs: MarketplaceRfq.AsObject[]) => {
      this.cancelledRfq$$.next(
        (rfqs && rfqs.filter((rfq) => rfq.status === MarketplaceRfqStatus.RFQ_STATUS_CANCELLED)) || null,
      );
    });
  }
  public ngOnDestroy() {
    // this.marketplaceService.clearSelectedRfq();
  }
}
